<div class="summary-item__title">{{ label }}</div>
<div class="summary-item__value">{{ value }}</div>
<app-icon *ngIf="iconClass" icon="{{ iconClass }}"></app-icon>
